import ProjectModalLinks from './project-modal-links';

export default class {
    constructor() {
        new ProjectModalLinks(document.querySelector('.main'));
    }
}
